import {
  FocusCycler,
  FocusableView as FocusableViewType,
  View,
  ViewCollection,
  FocusTracker,
  KeystrokeHandler,
  Locale,
} from "ckeditor5";

export default abstract class FocusableView extends View {
  private focusTracker: FocusTracker;
  private keystrokeHandler: KeystrokeHandler;

  protected focusables: ViewCollection<FocusableViewType>;

  constructor(locale: Locale) {
    super(locale);

    this.focusTracker = new FocusTracker();
    this.keystrokeHandler = new KeystrokeHandler();
    this.focusables = new ViewCollection();

    new FocusCycler({
      focusables: this.focusables,
      focusTracker: this.focusTracker,
      keystrokeHandler: this.keystrokeHandler,
      actions: {
        focusPrevious: "shift + tab",
        focusNext: "tab",
      },
    });
  }

  override render() {
    super.render();

    if (this.element != null) {
      this.keystrokeHandler.listenTo(this.element);
    }

    this.keystrokeHandler.set("Esc", (_data, cancel) => {
      this.fire("closeRequest");
      cancel();
    });

    for (const focusable of this.focusables) {
      if (focusable.element == null) continue;
      this.focusTracker.add(focusable.element);
    }
  }

  override destroy() {
    super.destroy();

    this.focusTracker.destroy();
    this.keystrokeHandler.destroy();
  }
}
